import { Box, Button, Container, Paper, Stack, Typography } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useSearchParams } from "react-router-dom";

export default function NachrichtGesendet() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const typeKey = type === "kontakt" || type === "termin" || type === "angebot" ? type : undefined;
  const subtitle = typeKey
    ? t(`successPage.types.${typeKey}.subtitle`, { defaultValue: t("successPage.hero.subtitle") })
    : t("successPage.hero.subtitle");
  const bullets = (typeKey
    ? t(`successPage.types.${typeKey}.bullets`, { returnObjects: true })
    : t("successPage.bullets", { returnObjects: true })) as string[];

  return (
    <Container sx={{ py: { xs: 4, md: 6 } }}>
      <Box className="hero-shell" sx={{ p: { xs: 4, md: 6 }, position: "relative", mb: { xs: 4, md: 6 } }}>
        <Box className="hero-glow" />
        <Stack spacing={2} sx={{ position: "relative", zIndex: 1, maxWidth: 720 }}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <CheckCircleRoundedIcon color="success" fontSize="large" />
            <Typography variant="h1">{t("successPage.hero.title")}</Typography>
          </Stack>
          <Typography variant="body1" sx={{ opacity: 0.85 }}>
            {subtitle}
          </Typography>
        </Stack>
      </Box>

      <Paper elevation={0} sx={{ p: { xs: 3, md: 4 }, border: "1px solid var(--border)", background: "var(--surface)" }}>
        <Stack spacing={2}>
          {bullets.map((bullet) => (
            <Stack key={bullet} direction="row" spacing={1.5} alignItems="center">
              <CheckCircleRoundedIcon color="success" fontSize="small" />
              <Typography variant="body1">{bullet}</Typography>
            </Stack>
          ))}
        </Stack>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mt: 3 }}>
          <Button component={RouterLink} to="/" variant="contained">
            {t("successPage.ctaPrimary")}
          </Button>
          <Button component={RouterLink} to="/kontakt" variant="outlined" color="inherit">
            {t("successPage.ctaSecondary")}
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
}
